import CloseIcon from '@components/BottomSheets/CloseIcon';
import FilterContext from '@components/Filter/context/FilterContext';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useContext } from 'react';

import FilterBottomSheetContents from './FilterBottomSheetContents';
import useFilterBottomSheet from './hooks/useFilterBottomSheet';

function FilterExpand() {
    const { title, setIsOpen } = useContext(FilterContext);
    const { isHide, isNone } = useFilterBottomSheet();

    return (
        <Dim isHide={isHide} isNone={isNone}>
            <Container isHide={isHide}>
                <Header>
                    <Text size='lg' fontWeight='bold'>{title}</Text>
                    <CloseIcon onClick={() => setIsOpen(false)}/>
                </Header>
                <FilterBottomSheetContents/>
            </Container>
        </Dim>
    );
}

const Dim = styled.div<{
    isHide: boolean;
    isNone: boolean;
}>`
    background-color: rgba(33, 33, 33, 0.75);
    display: ${({ isNone }) => (isNone ? 'none' : 'flex')};
    flex-direction: column;
    height: 100vh;
    justify-content: flex-end;
    left: 0;
    position: fixed;
    top: 0;
    transition: 250ms ease-in-out;
    width: 100vw;
    z-index: 9999;
    opacity: ${({ isHide }) => (isHide ? 0 : 1)};
`;

const Container = styled.div<{
    isHide: boolean;
}>`
    background-color: var(--color-white);
    border-radius: 12px 12px 0 0;
    margin: 0 auto;
    max-height: 90vh;
    max-width: var(--max-view-port-width);
    padding-bottom: var(--safe-area-bottom);
    transition: 250ms ease-in-out;
    width: 100%;
    transform: ${({ isHide }) => (isHide ? 'translateY(100%)' : 'none')};
        
    @media (max-width: 768px) {
        max-width: unset;
    }
`;

const Header = styled.header`
    align-items: center;
    border-bottom: 1px solid var(--color-gray3);
    display: flex;
    justify-content: center;
    padding: 20px 0;
    position: relative;
`;

export default FilterExpand;
